import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type ExportServicePackTranslationForm = {
  destinationLanguage: string;
  sylobProduct: string;
  sylobVersion: string;
  sylobMavenVersion: string;
  referenceTranslationId?: number;
  translationDueDate: string;
};

export const exportServicePackTranslation = async (data: ExportServicePackTranslationForm): Promise<number | null> => {
  const response = await axiosInstance.post<ApiResponse<number>>(
    `/api/translation/extract-service-pack-translation`,
    data
  );
  return response.data.data;
};
